var _defs, _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardKlarna(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffb3c7;}.cls-2{fill:#0a0b09;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 120,
    height: 80,
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10,
    y: 12.22,
    width: 100,
    height: 55.56,
    rx: 9.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.65,44.77A2.39,2.39,0,1,0,103,47.16,2.38,2.38,0,0,0,100.65,44.77Zm-7.79-1.85a3.42,3.42,0,1,0-3.42,3.27A3.34,3.34,0,0,0,92.86,42.92Zm0-6.36h3.78V49.28H92.87v-.81a6.6,6.6,0,0,1-3.74,1.16,6.71,6.71,0,0,1,0-13.42,6.6,6.6,0,0,1,3.74,1.16v-.81Zm-30.2,1.66V36.56H58.8V49.28h3.88V43.34c0-2,2.15-3.08,3.64-3.08h.05v-3.7a4.65,4.65,0,0,0-3.7,1.66ZM53,42.92a3.42,3.42,0,1,0-3.42,3.27A3.34,3.34,0,0,0,53,42.92Zm0-6.36h3.78V49.28H53.05v-.81a6.58,6.58,0,0,1-3.74,1.16,6.71,6.71,0,0,1,0-13.42,6.58,6.58,0,0,1,3.74,1.16v-.81Zm22.72-.34A4.58,4.58,0,0,0,71.88,38V36.56H68.12V49.28h3.81V42.6a2.66,2.66,0,0,1,2.83-2.88c1.66,0,2.61,1,2.61,2.85v6.71h3.77V41.19c0-3-2.33-5-5.37-5ZM37.16,49.28h4V30.89h-4Zm-17.35,0H24V30.89H19.81Zm14.63-18.4a14.7,14.7,0,0,1-4.28,10.44l5.78,8H30.78l-6.29-8.65,1.62-1.23a10.59,10.59,0,0,0,4.24-8.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardKlarna);
export default __webpack_public_path__ + "static/media/card_klarna.38fb1a696a08e250eb6d8d74525b75d5.svg";
export { ForwardRef as ReactComponent };